import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import './Calendario.css';
import { Grid } from '@material-ui/core';

class Calendario extends Component {
  render() {
    return (
      <React.Fragment>
        <ul className="weekdays">
          <li>Dom</li>
          <li>Seg</li>
          <li>Ter</li>
          <li>Qua</li>
          <li>Qui</li>
          <li>Sex</li>
          <li>Sab</li>
        </ul>
        <ul className="days">
          {this.props.days.map((day) => (
            <li key={day.number}>
              <Grid container justify="center" className={day.class}>
                <Tooltip disableFocusListener disableTouchListener title={day.title}>
                  <Button style={{minWidth: '32px'}}>{day.number}</Button>
                </Tooltip>
              </Grid>
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}

export default Calendario;